module.exports = __webpack_public_path__ + "img/exclimation-mark.68c3f9c0.svg";